import { StandardPostDetailedMetricAdditionalData } from 'app/types/StandardPostDetailed';

export const shouldShowMetricRowExpanded = (
  value: string | number | null,
  additionalData?: StandardPostDetailedMetricAdditionalData[],
) => additionalData && typeof value === 'number' && value > 0;
